import Components from "slotworks/components/components";
import Contract from "slotworks/utils/contracts/contract";

export function ShowLinesCommand(lines: number | number[]): Contract<void> {

    if (typeof lines === "number") {
        const linesArr = [];

        for (let i = 1; i <= lines; i++) {
            linesArr.push(i);
        }

        lines = linesArr;
    }

    for (const line of lines) {
        Components.lines.win(line);
    }

    return Contract.empty();
}
